import React, { useState } from "react";
import { Upload, Button, Input } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useIntl } from "react-intl";

const Uploader = (props) => {
  const { onFileSelected, onFileNameChanged } = props;
  const intl = useIntl();
  const [fileList, setFileList] = useState([]);

  const uploadProps = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
      onFileSelected(null);
    },
    beforeUpload: (file) => {
      setFileList([file]);
      onFileSelected(file);
      return false;
    },
    fileList,
  };

  const onChange = ({ target: { value } }) => {
    onFileNameChanged(value);
  };
  return (
    <div style={{ display: "flex", paddingTop: "20px" }}>
      <div style={{ width: "240px" }} />
      <div style={{ width: "200px" }}>
        <Upload {...uploadProps}>
          <Button icon={<UploadOutlined />}>
            {intl.formatMessage({
              id: "app.work_diary.selectFile",
            })}
          </Button>
        </Upload>
      </div>
      <div style={{ width: "40px" }} />
      <Input
        onChange={onChange}
        placeholder={intl.formatMessage({
          id: "app.work_diary.filename",
        })}
        style={{ width: "200px", height: "fit-content" }}
      />
    </div>
  );
};
export default Uploader;
